<div mat-dialog-title>
  <span>{{ modalTitle | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-credit-balance-warning
  #creditWarning
  [hidden]="!(isFree() || hasSubscription())"
  [actionKey]="'GENERATE_DRILLDOWN_VIA_AI'"></q9-credit-balance-warning>

<mat-dialog-content #generateForm class="dialog-content">
  <form [formGroup]="form" #formTemplate="ngForm">
    <ng-container
      *ngIf="
        enterpriseGenerationEnabled() && !permissionLoading();
        else enterpriseGenerationMessage
      ">
      <q9-select
        [label]="'AUTOGENERATE_DRILLDOWN.GENERATION_TYPE' | translate"
        formControlName="generationType">
        <q9-option *ngFor="let type of generationTypes()" [value]="type.value">
          {{ type.label | translate }}
        </q9-option>
      </q9-select>
      <q9-text-field
        formControlName="activity"
        [label]="'AUTOGENERATE_DRILLDOWN.ACTIVITY_LABEL'"></q9-text-field>
      <div
        [ngClass]="{
          intentForDiagram: intentForDiagramField.value
        }">
        <q9-text-field
          formControlName="intentForDiagram"
          [hint]="
            intentForDiagramField.value
              ? ('AUTOGENERATE_DRILLDOWN.DESCRIPTION_HINT' | translate)
              : ''
          "
          [label]="'AUTOGENERATE_DRILLDOWN.INTENT_FOR_DIAGRAM_LABEL'"></q9-text-field>
      </div>
      <q9-textarea-field
        formControlName="guidance"
        [label]="'AUTOGENERATE_DRILLDOWN.GUIDANCE_LABEL'"
        [hint]="'AUTOGENERATE_DRILLDOWN.GUIDANCE_HINT' | translate"></q9-textarea-field>

      <mat-slide-toggle
        class="toggle"
        q9Track="'MAP_SKIP_NEW_RESOURCES_GENERATION'"
        formControlName="skipNewResources">
        <span class="inner-text q9-section-data">
          {{ 'AUTOGENERATE_DRILLDOWN.ONLY_EXISTING_RESOURCES_LABEL' | translate }}
        </span>
      </mat-slide-toggle>

      <div class="image-upload" *ngIf="isImageGenerationType">
        <ng-container *ngIf="canAttachImages()">
          <q9-image-generation-import
            [images]="images"
            [presetImages]="imagePreviews"
            (imageAdded)="scrollToBottom()"></q9-image-generation-import>
        </ng-container>

        <q9-info-message *ngIf="!canAttachImages()" type="warn">
          {{ 'AUTOGENERATE_DRILLDOWN.IMAGE_WARNING_PT1' | translate }}
          <a href="https://platform.openai.com/docs/models" target="_blank" class="remove-anchor">
            {{ 'AUTOGENERATE_DRILLDOWN.IMAGE_WARNING_PT2' | translate }}
          </a>
          {{ 'AUTOGENERATE_DRILLDOWN.IMAGE_WARNING_PT3' | translate }}
        </q9-info-message>
      </div>
    </ng-container>
  </form>
  <ng-template #enterpriseGenerationMessage>
    <div *ngIf="!permissionLoading(); else loader">
      {{ 'AUTOGENERATE_DRILLDOWN.EXTERNAL_GENERATION_MESSAGE' | translate }}
    </div>
  </ng-template>
  <ng-template #loader>
    <q9-content-loader [isLoading]="true"></q9-content-loader>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions mat-dialog-actions align="end">
  <q9-icon-button icon="information-icon" (click)="goToArticle()"></q9-icon-button>
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-primary-button
    *ngIf="enterpriseGenerationEnabled()"
    q9Track="MAP.AUTO_GENERATE_DRILLDOWN"
    [disabled]="!creditWarning.canProceed()"
    (click)="formTemplate.onSubmit($event); generate()">
    {{ 'AUTOGENERATE_DRILLDOWN.GENERATE' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
